import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { DataService } from "./data.service";
import {
  style,
  state,
  animate,
  transition,
  trigger,
} from "@angular/animations";

@Component({
  selector: "app-portfolio",
  templateUrl: "./portfolio.component.html",
  styleUrls: ["./portfolio.component.css"],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        // :enter is alias to 'void => *'
        style({ transform: "scale(0)", "transform-origin": "top left" }),
        animate(
          500,
          style({ transform: "scale(1)", "transform-origin": "top left" })
        ),
      ]),
      transition(":leave", [
        // :leave is alias to '* => void'
        animate(
          500,
          style({ transform: "scale(0)", "transform-origin": "top left" })
        ),
      ]),
    ]),
  ],
})
export class PortfolioComponent implements OnInit {
  categories = [];
  projects = [];
  selectedProjects = [];
  selectedCategory = "all";
  constructor(
    private dataService: DataService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.categories = this.dataService.getCategories();
    this.projects = this.dataService.projectList();
    this.chooseCategory(this.selectedCategory);
  }

  chooseCategory(categoryId: string): void {
    this.selectedCategory = categoryId;
    if (categoryId === "all") {
      this.selectedProjects = this.projects;
    } else {
      this.selectedProjects = this.projects.filter(
        (project) => project.category === categoryId
      );
    }
  }

  getSanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
